import { FC } from 'react'
import { StyledIssueStatus } from './IssueStatus.styles'
import { IssueStatusProps } from './IssueStatus.types'
import Typography from '../typography'
import CircleIndicator from '../circle-indicator'

const IssueStatus: FC<IssueStatusProps> = ({ status, className, testId, isInProcess }) => {
    const getStatusText = (status: TIssueStatus) => {
        switch (status) {
            case 'open':
                return 'Open'
            case 'in_review':
                return 'Validating'
            case 'resolved':
                return 'Resolved'
            case 'approved':
                return 'Approved'
            default:
                return 'Validating'
        }
    }

    if (isInProcess) {
        return <CircleIndicator size={18} loading={true} width={2} />
    }

    return (
        <StyledIssueStatus
            status={status}
            className={className}
            data-testid={testId}
        >
            <Typography variant="s-regular">
                {getStatusText(status)}
            </Typography>
        </StyledIssueStatus>
    )
}

export default IssueStatus
